export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/schedule/resources/mounted.js